<template>
  <v-app :style="cssProps">
    <v-main class="mb-4">
      <router-view />
    </v-main>

    <v-footer fixed class="eos-footer">
      <v-row
        class="mx-auto text-caption font-sahel"
        style="color: var(--color-accent) !important"
      >
        <v-col cols="auto" class="font-sahel hidden-sm-and-down">{{
          $t("footer")
        }}</v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">{{ $t("today") }} : {{ date }}</v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  mounted() {
    
    this.loadTheme();
  },
  /*created() {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      console.log("Service Worker and Push is supported");

      navigator.serviceWorker
        .register("/service-worker.js")
        .then(function (swReg) {
          console.log("Service Worker is registered");
          console.log(swReg);
        })
        .catch(function (error) {
          console.error("Service Worker Error", error);
        });
    } else {
      console.warn("Push messaging is not supported");
    }
  },*/
  methods: {
    
  },

  computed: {
    date() {
      let today = new Date().toLocaleDateString("fa-IR");
      ////console.log(today);
      return today;
    },
    cssProps() {
      return {
        "--color-primary": this.$vuetify.theme.dark
          ? this.$vuetify.theme.themes.dark.primary
          : this.$vuetify.theme.themes.light.primary,
      };
    },
  },
  data: () => ({}),
};
</script>

<style>
@font-face {
  font-family: "Sahel";
  src: url("./assets/fonts/Sahel-FD.eot"),
    url("./assets/fonts/Sahel-FD.woff") format("woff"),
    /* Pretty Modern Browsers */ url("./assets/fonts/Sahel-FD.ttf")
      format("truetype"); /* Safari, Android, iOS */
}
* {
  font-family: "Sahel", Helvetica, Arial !important;
}

#app {
  background-color: var(--background) !important;
}

.eos-footer {
  height: 30px;
}

.v-overlay__scrim {
  height: calc(100% - 30px) !important;
}
.mdi-lock-reset::before {
  color: red;
}
.mdi-account::before {
  color: #ff9900;
}
.mdi-transit-transfer::before {
  color:#668cff ;
}
.mdi-poll::before {
  color: lightcoral;
}
.mdi-order-bool-descending-variant::before {
  color: rgb(89, 138, 40);
}
.mdi-robot-confused-outline::before {
  color:goldenrod;
}
.mdi-tune::before {
    color: lightseagreen;
}
.mdi-comment-text-multiple-outline::before {
    color: chocolate;
}
.vpd-input-group input:not(.vpd-is-editable) {
    background-color: white;
}
.mdi-view-dashboard-outline::before {
    color: darkorange;
}
.mdi-account-group::before {
    color: yellowgreen;
}
.mdi-account-multiple-check::before {
    color: violet;
}
.mdi-account-multiple-remove::before {
    color: tomato;
}
.mdi-shield-account-outline::before {
    color: sienna;
}
.mdi-car-shift-pattern::before {
    color: orange;
}
.mdi-table-account::before {
    color: lightslategray;
}
.mdi-clipboard-list-outline::before {
    color: #00bf55;
}
.mdi-map::before {
    color: #fdb126;
}
.mdi-chart-areaspline::before {
    color: #9fa5ad;
}
.vpd-input-group input {
  background-color: white;
}


/* tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.329);
} */
/* tbody tr:nth-of-type(odd) {
  background-color: rgb(179 176 88 / 33%);
} */
/* tbody tr:nth-of-type(odd) {
    background-color: rgb(158 51 165 / 33%);
} */
/* tbody tr:nth-of-type(odd) {
    background-color: rgb(51 154 165 / 33%);
} */
/* tbody tr:nth-of-type(odd) {
    background-color: rgb(237 37 5 / 33%);
} */
</style>